<template lang="pug">
content-page
	div(slot="nav")
		v-btn.hidden-md-and-up.mb-6(color="primary" outlined block nuxt exact :to="localePath({name:'gear'})") &laquo; terug naar materiaal
		nav
			.subtitle-1 {{$t('page.gear:feature:nav_heading')}}
			ul.list-unstyled
				li(v-for="category in categories" v-if="category.products.length")
					nuxt-link(:to="localePath({name:'gear-category', params: {category: category.slug}})")
							| {{category.name}}
							|
							small.grey--text ({{category.products.length}})
	.hidden-sm-and-down(slot="sidebar" style="max-width: 280px;")
		ad(location="sidebar").mb-6
		offers.mb-6
	.flow-left
		h1 {{feature.name}}
		ws-content(:value="feature.content")
		template(v-for="option in feature.options" v-if="option.content.markdown !== ''")
			h2 {{option.name}}
			ws-content(:value="option.content")

</template>

<script>
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import Content from '@dengl/common/components/content.vue';

const gearFeaturePage = gql`
	query gearFeaturePage($slug: String) {
		feature: gearFeature(slug: $slug) {
			id
			name
			slug
			...MetaFragment
			content {
				...ContentDataFragment
			}
			options {
				name
				content {
					...ContentDataFragment
				}
			}
		}
		categories: gearCategories {
			id
			slug
			name
			products {
				id
			}
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/materiaal/kenmerken/:slug',
			'nl-BE': '/materiaal/kenmerken/:slug'
		}
	},
	layout: 'default',

	asyncData({ params, app }) {
		return app.$graphClient
			.query({
				query: gearFeaturePage,
				variables: {
					slug: params.slug
				},
				errorPolicy: 'all',
				fetchPolicy: 'network-only'
			})
			.then(({ data, errors }) => {
				if (!data.feature) {
					return app.httpError(404, null, 'gear-features-feature-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.meta(data.feature.meta);
				app.ads({});
				app.breadcrumbs({
					[app.i18n.t('page.gear:breadcrumb')]: {
						name: 'gear'
					},
					[data.feature.name]: {
						name: 'gear-features-feature'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'gear-features-feature-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
